import { ThemeProvider } from "@shared/EDS/contexts/ThemeProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Settings } from "luxon";
import React from "react";
import { ConfigProvider } from "./common/contexts/config/configProvider";

interface BaseWrapperProps {
  readonly children: React.JSX.Element;
}

const queryClient = new QueryClient();
Settings.defaultZone = "Europe/Amsterdam";
Settings.defaultLocale = "nl-NL";

export function BaseWrapper({ children }: BaseWrapperProps): React.JSX.Element {
  return (
    <React.StrictMode>
      <ThemeProvider>
        <ConfigProvider>
          <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </ConfigProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
}
